<template>
  <div class='solver'>
    <v-text-field v-model='move' @keydown.enter='submitMove' :disabled='!inputEnabled' />
    <span>{{solverName}}</span><br/>
    <span>{{currentTime}}</span>
  </div>
</template>

<script>
import FMCService from '@/services/FMCService'

export default {
  name: 'solver',
  data () {
    return {
      move: '',
      currentTime: 300000,
      timeElapsed: 0,
      timer: 0,
    }
  },
  props: {
    inputEnabled: Boolean,
    tickDown: Boolean,
    state: Object,
    solverName: String,
  },
  methods: {
    async submitMove () {
      if (!this.isValidMove(this.move)) return

      const {data} = await FMCService.submitMove({
        sessionID: this.sessionID,
        timeElapsed: Math.round(window.performance.now() - this.realTimeStart),
        move: this.move,
      })

      if (data.error) {
        console.log(`Error: ${data.error} - ${data.message}`) // NOTE: don't alert since that might mess up their timing... just eat the input
      }
      
      this.realTimeStart = window.performance.now() // sometimes we need this in single player since tickDown isn't toggled
    },
    async submitResult (resultType) {
      if (!this.inputEnabled) return

      let winner = false
      if (resultType === 'timeout') winner = false
      if (resultType === 'cubeSolved') winner = true

      this.stopTimer({timeRemaining: 0})
      const {data} = await FMCService.submitResult({
        sessionID: this.sessionID,
        winner, resultType,
      })

      if (data.error) {
        alert(`Error: ${data.error} - ${data.message}`)
      }
    },
    isValidMove (move) {
      return !!move // TODO: improve move validation
    },
    startTimer () {
      this.currentTime = this.state.timeRemaining
      this.realTimeStart = window.performance.now()
      this.timer = setInterval(() => {
        this.currentTime = (this.state.timeRemaining - (window.performance.now() - this.realTimeStart))
        if (this.currentTime <= 0) this.submitResult('timeout')
      }, 10)
    },
    stopTimer (overrideState) {
      if (!overrideState) this.currentTime = this.state.timeRemaining
      else this.currentTime = overrideState.timeRemaining
      clearInterval(this.timer)
    },
  },
  watch: {
    tickDown: {
      immediate: true,
      handler () {
        if (this.tickDown) {
          this.startTimer()
        } else {
          this.stopTimer()
        }
      }
    }
  },
  computed: {
    sessionID () {
      return this.$route.params.sid
    },
  },
}
</script>
